import axios from 'axios';
import store from '../store/store'

export default function authHeaderInterceptor() {
    axios.interceptors.request.use(function(config) {
        const token = store.getters['user/tokenString'];
        if(token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    }, function(err) {
        return Promise.reject(err);
    });
}